<template>
    <ViewBase class="view-marketplace-item">

        <MarketViewer :id="id" @close="handleClose" />
        <CellSpace />

    </ViewBase>
</template>

<script>
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { ViewBase } from '@generio-ai/library-legacy/components/views'
import { MarketViewer } from '@generio-ai/library-legacy/components/market'
import { CellSpace } from '@generio-ai/library-legacy/components/cells'

export default {
    name: 'ViewMarketItem',
    components: {
        ViewBase,
        MarketViewer,
        CellSpace
    },
    props: {
        id: {
            type: String,
            default: null
        }
    },
    methods: {
        ...mapActions('analytics', [
            'logEvent'
        ]),
        ...mapActions('overlay', [
            'hide'
        ]),
        ...mapActions('router', [
            'openRoute'
        ]),

        handleClose() {
            // log event
            this.logEvent({
                name: "navigate_to_store_overview",
                description: "Closed Selected Item in Store Item",
                additional: {
                    funnel_name: 'generic',
                    funnel_step: 2
                }
            })

            this.$router.push('/market')
        }
    },
    mounted() {
        this.hide()
    }
}
</script>

<style>
.v-label {
    font-size: 0.85rem !important;
}
</style>